import { formatTemperature } from '@packages/utils';

function temperatureFormatter({ value }: { value: number }) {
  return value != null ? formatTemperature(value, 1) : '-';
}

export default temperatureFormatter;
